import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailPropertiesService } from '../../service/trail-properties.service';
import { TrailDocumentFmea } from '../../dto/trail-document-fmea';
import { BoolDto } from '../../../../common/dto/bool-dto';

@Component({
  selector: 'dpi-trail-document-fmea-detail',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-document-fmea-detail.component.html',
  styleUrl: './trail-document-fmea-detail.component.scss'
})
export class TrailDocumentFmeaDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailDocumentFmeaDetailComponent>);
  trailDocuFMEA: TrailDocumentFmea;
  isToUpdate: boolean;
  isToDelete: boolean;
  
  fmea_findings_closed_States: BoolDto[];
  fmea_findings_closed: BoolDto;

  trail_findings_closed_States: BoolDto[];
  trail_findings_closed: BoolDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailDocumentFmea, private trailPropertiesService: TrailPropertiesService) {
    this.trailDocuFMEA = data;
    this.isToUpdate = false;
    this.isToDelete = false;

    this.fmea_findings_closed_States = this.trailPropertiesService.getAllTrialBinaryStates();
    this.fmea_findings_closed = this.trailPropertiesService.getTrialSetupBinaryState(this.fmea_findings_closed_States, data.fmea_findings_closed);
    
    this.trail_findings_closed_States = this.trailPropertiesService.getAllTrialBinaryStates();
    this.trail_findings_closed = this.trailPropertiesService.getTrialSetupBinaryState(this.trail_findings_closed_States, data.trail_findings_closed);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.trailDocuFMEA.fmea_findings_closed = this.fmea_findings_closed.state;
    this.trailDocuFMEA.trail_findings_closed = this.trail_findings_closed.state;
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
